export const MEMBER_FIELD = `{id: memberId, name: memberName}`

/**
 * 品种
 */
export const KIND_FIELD = `{name: kindNames,id: kindIds}`

/**
 * 竞价预告
 */
export const ANNOUNCEMENT_FIELD = `{id: announcementId,title: announcementTitle}`
